module.exports = __webpack_public_path__ + "static/media/ils-field@3x.3b3a59c6.png";